/* SwarnHouse site helpers:
   0) brand recolour: swaps leftover Kalles demo orange/cyan for SwarnHouse rust
   1) plays the dropdown animation only once the theme has actually shown the panel
   2) typing animation for menu labels such as "coming soon"
   3) premium inline header search (desktop) with live product suggestions */
(function () {
  if (window.__shMenuInit) return;
  window.__shMenuInit = true;
  var desktop = window.matchMedia('(min-width: 1025px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- 0. Brand recolour ---------- */
  var OLD_COLOURS = /#(ff4e00|56cfe1|00badb)\b/gi;
  var BRAND = '#B5502F';
  function recolour(scope) {
    scope = scope || document;
    try {
      Array.prototype.forEach.call(scope.querySelectorAll('style'), function (st) {
        if (st.id === 'sh-hsearch-css') return;
        var t = st.textContent;
        if (t && OLD_COLOURS.test(t)) { OLD_COLOURS.lastIndex = 0; st.textContent = t.replace(OLD_COLOURS, BRAND); }
        OLD_COLOURS.lastIndex = 0;
      });
      Array.prototype.forEach.call(scope.querySelectorAll('[style*="#"]'), function (el) {
        var s = el.getAttribute('style');
        if (s && OLD_COLOURS.test(s)) { OLD_COLOURS.lastIndex = 0; el.setAttribute('style', s.replace(OLD_COLOURS, BRAND)); }
        OLD_COLOURS.lastIndex = 0;
      });
    } catch (e) {}
  }

  function isShown(el) {
    var cs = window.getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.01;
  }

  /* ---------- 1. Dropdown opening animation ---------- */
  function bindDropdowns() {
    var items = document.querySelectorAll('.t4s-nav__ul > li.has--children');
    Array.prototype.forEach.call(items, function (li) {
      if (li.__shBound) return;
      li.__shBound = true;
      var frame = null;
      li.addEventListener('mouseenter', function () {
        if (!desktop.matches) return;
        var sub = li.querySelector(':scope > .t4s-sub-menu');
        if (!sub) return;
        li.classList.remove('sh-open');
        if (frame) cancelAnimationFrame(frame);
        var started = performance.now();
        (function waitForPanel() {
          if (isShown(sub)) { void sub.offsetWidth; li.classList.add('sh-open'); return; }
          if (performance.now() - started < 2500) frame = requestAnimationFrame(waitForPanel);
        })();
      });
      li.addEventListener('mouseleave', function () {
        if (frame) cancelAnimationFrame(frame);
        li.classList.remove('sh-open');
      });
    });
  }

  /* ---------- 2. Typing animation for menu labels (e.g. "coming soon") ---------- */
  var TYPE_SPEED = 95, ERASE_SPEED = 45, HOLD_FULL = 1800, HOLD_EMPTY = 500;
  function typeLabels() {
    if (reduceMotion) return;
    var labels = document.querySelectorAll('.t4s-nav__ul .t4s_lb_nav');
    Array.prototype.forEach.call(labels, function (lb) {
      if (lb.__shType) return;
      var full = (lb.textContent || '').trim();
      if (!full) return;
      lb.__shType = true;
      var width = lb.getBoundingClientRect().width;
      lb.classList.add('sh-typing');
      if (width > 0) lb.style.minWidth = Math.ceil(width + 6) + 'px';
      var text = document.createElement('span');
      var caret = document.createElement('span');
      caret.className = 'sh-caret';
      caret.setAttribute('aria-hidden', 'true');
      lb.setAttribute('aria-label', full);
      lb.textContent = '';
      lb.appendChild(text);
      lb.appendChild(caret);
      var i = 0, typing = true;
      function tick() {
        if (typing) {
          i++; text.textContent = full.slice(0, i);
          if (i >= full.length) { typing = false; setTimeout(tick, HOLD_FULL); return; }
          setTimeout(tick, TYPE_SPEED);
        } else {
          i--; text.textContent = full.slice(0, i);
          if (i <= 0) { typing = true; setTimeout(tick, HOLD_EMPTY); return; }
          setTimeout(tick, ERASE_SPEED);
        }
      }
      setTimeout(tick, 600);
    });
  }

  /* ---------- 3. Premium inline header search (desktop only) ---------- */
  var QUICK_LINKS = ['Buddha', 'Ganesha', 'Water Fountain', 'Wall Decor', 'Krishna'];
  var searchCss =
    '.t4s-section-header .t4s-site-nav__search{position:relative}' +
    '.sh-hsearch{position:absolute;right:calc(100% + 2px);top:50%;transform:translateY(-50%);width:0;opacity:0;pointer-events:none;z-index:470;' +
      'transition:width .45s cubic-bezier(.2,.8,.2,1),opacity .25s ease}' +
    '.sh-hsearch.is-open{width:clamp(230px,22vw,340px);opacity:1;pointer-events:auto}' +
    '.sh-hsearch__form{display:flex;align-items:center;height:42px;margin:0;padding:0 5px 0 18px;background:#fff;border:1px solid #E3D8C4;border-radius:999px;' +
      'box-shadow:0 8px 20px -12px rgba(91,70,48,.35);overflow:hidden;transition:border-color .2s ease,box-shadow .2s ease}' +
    '.sh-hsearch__form:focus-within{border-color:#B5502F;box-shadow:0 0 0 3px rgba(181,80,47,.12),0 8px 20px -12px rgba(91,70,48,.35)}' +
    '.sh-hsearch__input{flex:1;min-width:0;height:100%;border:0 !important;background:transparent !important;box-shadow:none !important;outline:none !important;padding:0 !important;' +
      'font-size:14px;color:#2B2118;letter-spacing:.1px}' +
    '.sh-hsearch__input::placeholder{color:#A8977F}' +
    '.sh-hsearch__input::-webkit-search-cancel-button{-webkit-appearance:none}' +
    '.sh-hsearch__close{flex:0 0 30px;height:30px;border:0;border-radius:50%;background:transparent;color:#7A6A58;font-size:20px;line-height:1;cursor:pointer;padding:0;' +
      'transition:background .2s ease,color .2s ease}' +
    '.sh-hsearch__close:hover{background:#F1E6D4;color:#B5502F}' +
    '.sh-hsearch__panel{position:absolute;top:calc(100% + 10px);right:0;width:max(100%,380px);background:#FFFCF7;border:1px solid #EDE3D2;border-radius:14px;' +
      'box-shadow:0 18px 40px -12px rgba(91,70,48,.3);overflow:hidden;opacity:0;transform:translateY(8px);pointer-events:none;transition:opacity .25s ease,transform .3s cubic-bezier(.2,.8,.2,1)}' +
    '.sh-hsearch__panel:before{content:"";display:block;height:3px;background:#C9A24D}' +
    '.sh-hsearch.is-open .sh-hsearch__panel.is-visible{opacity:1;transform:none;pointer-events:auto}' +
    '.sh-hsearch__label{padding:14px 18px 8px;font-size:11px;letter-spacing:2px;text-transform:uppercase;color:#A8977F;text-align:left}' +
    '.sh-hsearch__chips{display:flex;flex-wrap:wrap;gap:8px;padding:0 18px 18px}' +
    '.sh-hsearch__chip{border:1px solid #E3D8C4;background:#fff;border-radius:999px;padding:6px 14px;font-size:13px;color:#5B4630;cursor:pointer;transition:all .2s ease}' +
    '.sh-hsearch__chip:hover{border-color:#B5502F;color:#B5502F;background:#FBF1EA}' +
    '.sh-hsearch__list{list-style:none;margin:0;padding:6px 8px 8px}' +
    '.sh-hsearch__item a{display:flex;align-items:center;gap:14px;padding:8px 10px;border-radius:10px;text-decoration:none;text-align:left;transition:background .2s ease}' +
    '.sh-hsearch__item a:hover,.sh-hsearch__item a:focus{background:#F6EEE1;outline:none}' +
    '.sh-hsearch__img{flex:0 0 52px;width:52px;height:52px;border-radius:8px;object-fit:cover;background:#F3EEE3}' +
    '.sh-hsearch__meta{min-width:0}' +
    '.sh-hsearch__title{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;font-size:13.5px;line-height:1.35;color:#2B2118}' +
    '.sh-hsearch__price{margin-top:3px;font-size:13px;font-weight:600;color:#B5502F}' +
    '.sh-hsearch__all{display:block;padding:12px 18px;border-top:1px solid #EDE3D2;font-size:13px;font-weight:500;color:#5B4630 !important;text-decoration:none !important;text-align:left;transition:background .2s ease}' +
    '.sh-hsearch__all:hover{background:#F6EEE1;color:#B5502F !important}' +
    '.sh-hsearch__msg{padding:16px 18px;font-size:13.5px;color:#7A6A58;text-align:left}' +
    '.t4s-site-nav__search.sh-search-active > a svg.t4s-icon{color:#B5502F !important}' +
    '@media (prefers-reduced-motion:reduce){.sh-hsearch,.sh-hsearch__panel{transition:none}}';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(p) {
    var n = parseFloat(p);
    if (isNaN(n)) return '';
    return 'Rs. ' + n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }

  function buildSearch(wrap) {
    if (wrap.__shSearch) return wrap.__shSearch;
    if (!document.getElementById('sh-hsearch-css')) {
      var st = document.createElement('style');
      st.id = 'sh-hsearch-css';
      st.textContent = searchCss;
      document.head.appendChild(st);
    }
    var box = document.createElement('div');
    box.className = 'sh-hsearch';
    box.innerHTML =
      '<form class="sh-hsearch__form" action="' + root + 'search" method="get" role="search">' +
        '<input type="hidden" name="type" value="product">' +
        '<input class="sh-hsearch__input" type="search" name="q" autocomplete="off" placeholder="Search Buddha, Ganesha, fountains\u2026" aria-label="Search products">' +
        '<button type="button" class="sh-hsearch__close" aria-label="Close search">&times;</button>' +
      '</form>' +
      '<div class="sh-hsearch__panel" aria-live="polite"></div>';
    wrap.insertBefore(box, wrap.firstChild);

    var form = box.querySelector('form');
    var input = box.querySelector('.sh-hsearch__input');
    var panel = box.querySelector('.sh-hsearch__panel');
    var timer = null, lastQ = '', controller = null;

    function showQuick() {
      panel.innerHTML = '<div class="sh-hsearch__label">Popular searches</div><div class="sh-hsearch__chips">' +
        QUICK_LINKS.map(function (q) { return '<button type="button" class="sh-hsearch__chip" data-q="' + esc(q) + '">' + esc(q) + '</button>'; }).join('') +
        '</div>';
      panel.classList.add('is-visible');
    }
    function render(q, products) {
      if (!products.length) {
        panel.innerHTML = '<div class="sh-hsearch__msg">No pieces found for \u201c' + esc(q) + '\u201d. Try another word.</div>';
      } else {
        panel.innerHTML = '<div class="sh-hsearch__label">Products</div><ul class="sh-hsearch__list">' +
          products.map(function (p) {
            var img = p.image || (p.featured_image && p.featured_image.url) || '';
            return '<li class="sh-hsearch__item"><a href="' + esc(p.url) + '">' +
              (img ? '<img class="sh-hsearch__img" src="' + esc(thumb(img)) + '" alt="" loading="lazy">' : '<span class="sh-hsearch__img"></span>') +
              '<span class="sh-hsearch__meta"><span class="sh-hsearch__title">' + esc(p.title) + '</span>' +
              '<span class="sh-hsearch__price">' + esc(money(p.price)) + '</span></span></a></li>';
          }).join('') + '</ul>' +
          '<a class="sh-hsearch__all" href="' + root + 'search?type=product&q=' + encodeURIComponent(q) + '">View all results for \u201c' + esc(q) + '\u201d &rarr;</a>';
      }
      panel.classList.add('is-visible');
    }
    function suggest(q) {
      if (controller && controller.abort) controller.abort();
      controller = window.AbortController ? new AbortController() : null;
      panel.innerHTML = '<div class="sh-hsearch__msg">Searching\u2026</div>';
      panel.classList.add('is-visible');
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (q !== lastQ) return;
          var prods = (d && d.resources && d.resources.results && d.resources.results.products) || [];
          render(q, prods);
        })
        .catch(function (err) { if (err && err.name === 'AbortError') return; panel.innerHTML = '<div class="sh-hsearch__msg">Press Enter to search.</div>'; });
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      lastQ = q;
      clearTimeout(timer);
      if (q.length < 2) { showQuick(); return; }
      timer = setTimeout(function () { suggest(q); }, 250);
    });
    input.addEventListener('focus', function () { if (input.value.trim().length < 2) showQuick(); });
    panel.addEventListener('click', function (e) {
      var chip = e.target.closest('.sh-hsearch__chip');
      if (!chip) return;
      input.value = chip.getAttribute('data-q');
      input.dispatchEvent(new Event('input'));
      input.focus();
    });
    box.querySelector('.sh-hsearch__close').addEventListener('click', function () { api.close(); });
    form.addEventListener('submit', function (e) { if (!input.value.trim()) { e.preventDefault(); input.focus(); } });

    var api = {
      box: box,
      isOpen: function () { return box.classList.contains('is-open'); },
      open: function () {
        box.classList.add('is-open');
        wrap.classList.add('sh-search-active');
        setTimeout(function () { input.focus(); }, 120);
      },
      close: function () {
        box.classList.remove('is-open');
        wrap.classList.remove('sh-search-active');
        panel.classList.remove('is-visible');
        input.blur();
      },
      submit: function () {
        if (input.value.trim()) form.submit(); else api.close();
      }
    };
    wrap.__shSearch = api;
    return api;
  }

  document.addEventListener('click', function (e) {
    if (!desktop.matches) return;
    var link = e.target.closest && e.target.closest('.t4s-section-header .t4s-site-nav__search > a');
    if (!link) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    var s = buildSearch(link.parentNode);
    if (s.isOpen()) s.submit(); else s.open();
  }, true);

  document.addEventListener('click', function (e) {
    var open = document.querySelectorAll('.sh-hsearch.is-open');
    Array.prototype.forEach.call(open, function (box) {
      var wrap = box.parentNode;
      if (!wrap.contains(e.target) && wrap.__shSearch) wrap.__shSearch.close();
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelectorAll('.sh-hsearch.is-open');
    Array.prototype.forEach.call(open, function (box) { if (box.parentNode.__shSearch) box.parentNode.__shSearch.close(); });
  });

  /* recolour content that the theme loads later (tabs, quick view, cart drawer) */
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; recolour(document); }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function init() {
    recolour(document);
    bindDropdowns();
    if (desktop.matches) typeLabels();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  if (desktop.addEventListener) desktop.addEventListener('change', function () { if (desktop.matches) typeLabels(); });
})();
